import authRules from '../authRules';

const isApprover = (user) => {
  const { status } = user.securityLevels;
  if (status >= authRules.isApprover.status) {
      return true;
  } else {
      return false;
    }
  }


export default isApprover;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/isApprover.js